import React, {createRef, useEffect} from "react";
import styles from "../../assets/css/modules/health-store/health-store.css";
import Store from "./../../content/Store";
import CenteredContentHero from "./CenteredContentHero";
import PromoImageCard from "../../components/shared/PromoImageCard";
import { Paths } from "../../constants/UrlConstants";
import { Redirect } from "react-router-dom";
import { Layouts } from "../../constants/Constants";
import Content from "../../content/Content";
import { connect } from "react-redux";
import HelpSection from "../shared/HelpSection";
import Contentify from "../../content/Contentify";

import Button from "../../components/shared/buttons/Button";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const mapStateToProps = (state) => {
  const policyDetails = state.policyReducer.policyDetails;
  const currentPolicy = state.policyReducer.selectedPolicy;
  const isInternationalOrSaga =
    currentPolicy && (currentPolicy.IsSaga || currentPolicy.IsInternational);
  const isLapsed = currentPolicy && currentPolicy.IsLapsed;
  const isIndividual = currentPolicy && currentPolicy.IsIndividual;
  const isSME = currentPolicy && currentPolicy.IsSME;
  const isLargeCorporate = currentPolicy && currentPolicy.IsLargeCorporate;
  return {
    CurrentPolicy: currentPolicy,
    PolicyDetails: policyDetails,
    isLapsed,
    isInternationalOrSaga,
    isIndividual,
    isSME,
    layout: state.layoutReducer && state.layoutReducer.layout,
    isLargeCorporate
  };
};


const getReferAFriendffer = () => {
  return (
    <React.Fragment>
      <div>
        <div>
          <div>
            <section>
              <div
                id="puregymPromo"
                className={"col-sm-12 " + styles.puregymPromo} >
                <PromoImageCard
                  ImgSrc={Store.HealthStore.MoreOfferSection.RefFrnd.IconSrc}
                  ImgSrcMobile={Store.HealthStore.MoreOfferSection.RefFrnd.IconSrcMobile}
                  Heading={Store.HealthStore.MoreOfferSection.RefFrnd.Heading}
                  Description={Store.HealthStore.MoreOfferSection.RefFrnd.Description}
                  LinkText={Store.HealthStore.MoreOfferSection.RefFrnd.LinkText}
                  LinkTo={Store.HealthStore.MoreOfferSection.RefFrnd.LinkTo}
                  IsExternalLink={true}
                  LeftImage={true}
                  IsNuffieldGym={Store.HealthStore.MoreOfferSection.RefFrnd.IsNuffieldGym}
                />
              </div>
            </section>
          </div>
        </div>
      </div>
      <hr />
    </React.Fragment>
  );
};

const getNuffieldOffer = () => {
  return (
    <React.Fragment>
      <h3 id="nuffieldOffer" className={styles.healthStoreSubHeading}>
        <Content name={Store.HealthStore.MoreOfferSection.OffSubHeading} />
      </h3>
      <p>
        <Content name={Store.HealthStore.MoreOfferSection.OffDescription} />
      </p>
      <Content name={Store.HealthStore.MoreOfferSection.OffDetails} />
    </React.Fragment>
  );
};

const getSMECustomerReferralSection = () => (

  <section id="molSmeCustomerReferral" ref={scrollDiv}>
    
    <h3 className={styles.healthStoreSubHeading}>
      <Content
        name={Store.HealthStore.MoreOfferSection.CustomerReferralSubHeading}
      />
    </h3>
    <p id="customerReferralDescription">
      <Content
        name={Store.HealthStore.MoreOfferSection.CustomerReferralDescription}
      />
    </p>
    <div className="row">
      <div className="Amazon-Offer-Button col-1 float-left">
        <Button
          label={Store.HealthStore.MoreOfferSection.ButtonLabel}

          onClick={(e) => {
            e.preventDefault();
            window.open('https://www.axahealth.co.uk/sme-refer-a-business');
          }}
          buttonType="primaryBlueButton"
          key="GetStartedButton"
          id="GetStartedButton"
        />
      </div>
    </div>
    <p className ="AmazonDescriptionkey" id="customerReferralDescription">
      <Content
        name={Store.HealthStore.MoreOfferSection.AmazonDescription}
      />
    </p>
    <p id="customerReferralTerms">
      <Content
        name={
          Store.HealthStore.MoreOfferSection.AmazonReferABusinessCondition
        }
      />
    </p>
  </section>
);

const getMoreOfferSection = function ({
  layout,
  isLapsed,
  isSME,
  isIndividual,
  isLargeCorporate
}) {
  const isHOL = layout === Layouts.HOL;
  const canShowHeading = ((isIndividual && !isLapsed && !isHOL) || isSME) || (isHOL && isSME);
 
  if (canShowHeading) {
    return (
      <section id="whatElseOnOffer" className={styles.sectionSpacing}>
        {isSME ? getSMECustomerReferralSection() : null}
        <h2 className={styles.healthStoreHeading}>
          <Content name={Store.HealthStore.MoreOfferSection.Heading} />
        </h2>
        {(isIndividual || isHOL)? (
          <section id="referAFriendOffer">
            {getReferAFriendffer()}
          </section>
        ) : null}

        {getNuffieldOffer()}
        {!(isSME || isIndividual || isLargeCorporate) ? (
          <React.Fragment><hr />
            <h3 className={styles.healthStoreSubHeading}>
              <Content name={Store.HealthStore.MoreOfferSection.AFWSubHeading} />
            </h3>
            <p>
              <Content name={Store.HealthStore.MoreOfferSection.AFWDescription} />
            </p>
            <p>
              <Content name={Store.HealthStore.MoreOfferSection.AFWDetails} />
            </p>
            <hr />
          </React.Fragment>) : null}
      </section>
    );
  } else if (isHOL && !isLapsed) {
    return (
      <section id="holNuffieldAndReferAFriendOffer" className={styles.sectionSpacing}>
        {getReferAFriendffer()}
        {getNuffieldOffer()}
      </section>
    );
  }
  return null;
};
const scrollDiv = createRef();
const HealthStore = function (props) {
  const search = useLocation().search;
  useEffect(() => {
    if (search) {
      const queryParams = new URLSearchParams(search);
      const val = queryParams.get('divRef');
      console.log(val);
      if (val === "puregymPromoSection") {
        const reftp = document.getElementById("puregymPromoSection");
        console.log(reftp);
        reftp.scrollIntoView({ behavior: "smooth" });
      } else if (val === "nuffieldOffer") {
        const reftp = document.getElementById("nuffieldOffer");
        console.log(reftp);
        reftp.scrollIntoView({ behavior: "smooth" });
      } else if (val === "molSmeCustomerReferral") {
        const reftp = document.getElementById("molSmeCustomerReferral");
        reftp.scrollIntoView({ behavior: "smooth" });
      } else if (val === "holNuffieldAndReferAFriendOffer") {
        const reftp = document.getElementById("holNuffieldAndReferAFriendOffer");
        reftp.scrollIntoView({ behavior: "smooth" });
       } else if (val === "referAFriendOffer") {
          const reftp = document.getElementById("referAFriendOffer");
        reftp.scrollIntoView({ behavior: "smooth" });
      }
      else
        scrollDiv.current.scrollIntoView({ behavior: "smooth" });
      console.log(scrollDiv);
    }
  }, [search]);

 const  scrollSmoothHandler = () => {
    scrollDiv.current.scrollIntoView({ behavior: "smooth" });
  };
  return props.isInternationalOrSaga ? (
    <Redirect to={Paths.NotFound} />
  ) : (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className={styles.containerShadow}>
                <CenteredContentHero Content={props.content} isExternalLink ShowGp={true}     UniqueKey=" "/>
                {!(props.isLapsed) ? (
                  <React.Fragment>
                    <section className={styles.sectionSpacing} name="puregymPromoSection" id="puregymPromoSection">
                      <div
                        id="puregymPromo"
                        className={"col-sm-12 " + styles.puregymPromo}
                      >
                        <PromoImageCard
                          ImgSrc={Store.HealthStore.Cards.IconSrc}
                          ImgSrcMobile={Store.HealthStore.Cards.IconSrcMobile}
                          Heading={Store.HealthStore.Cards.Heading}
                          Description={Store.HealthStore.Cards.Description}
                          LinkText={Store.HealthStore.Cards.LinkText}
                          LinkTo={Store.HealthStore.Cards.LinkTo}
                          IsExternalLink={true}
                          LeftImage={true}
                          IsNuffieldGym={Store.HealthStore.Cards.IsNuffieldGym}
                        />
                      </div>
                    </section>
                  </React.Fragment>) : null}
                <section className={styles.sectionSpacing} >
                  <div
                    id="puregymPromo"
                    className={"col-sm-12 " + styles.puregymPromo}
                  >
                    <PromoImageCard
                      ImgSrc={Store.HealthStore.HussleGymoffer.IconSrc}
                      ImgSrcMobile={Store.HealthStore.HussleGymoffer.IconSrcMobile}
                      Heading={Store.HealthStore.HussleGymoffer.Heading}
                      Description={Store.HealthStore.HussleGymoffer.Description}
                      LinkText={Store.HealthStore.HussleGymoffer.LinkText}
                      LinkTo={Store.HealthStore.HussleGymoffer.LinkTo}
                      IsExternalLink={true}
                      LeftImage={true}
                      IsNuffieldGym={Store.HealthStore.HussleGymoffer.IsNuffieldGym}
                    />
                  </div>
                </section>
                {(props.isSME) ? (
                  <section className={styles.sectionSpacing}>
                    <div
                      id="puregymPromo"
                      className={"col-sm-12 " + styles.puregymPromo}
                    >
                      <PromoImageCard
                        ImgSrc={Store.HealthStore.Amazonoffer.IconSrc}
                        ImgSrcMobile={Store.HealthStore.Amazonoffer.IconSrcMobile}
                        Heading={Store.HealthStore.Amazonoffer.Heading}
                        Description={Store.HealthStore.Amazonoffer.Description}
                        LinkText={Store.HealthStore.Amazonoffer.LinkText}
                        LinkTo={Store.HealthStore.Amazonoffer.LinkTo}
                        IsExternalLink={false}
                        LeftImage={true}
                        IsNuffieldGym={Store.HealthStore.Amazonoffer.IsNuffieldGym}
                        classname="AmazonOffer"
                        scrollSmoothHandler={scrollSmoothHandler}
                        scrollProperty={true}
                      >
                             </PromoImageCard>
                    </div>
                  </section>) : null}
                {getMoreOfferSection(props)}
                {!(props.isSME || props.isIndividual || props.isLargeCorporate) ? (
                  <React.Fragment>
                    <section className={styles.sectionSpacingHelpSection}>
                      <HelpSection
                        HeadingLinkTo={Paths.Help}
                        HeadingLinkText={Store.GeneralPages.HelpHeadingLinkText}
                        MoreHelpLinkTo={Paths.Help}
                        MoreHelpLinkText={Store.GeneralPages.MoreHelpLinkText}
                        HelpSet={Store.HealthStore.HelpSet}
                      />
                    </section>
                  </React.Fragment>) : null}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
};

HealthStore.content = Store.HealthStore.Hero;

export default connect(mapStateToProps)(Contentify(HealthStore));
